module.exports = __webpack_public_path__ + "img/Enviado.f32a3fea.png";